<template>
  <section class="container py-3">
    <div class="row">
      <div class="col-12 col-lg-6 offset-lg-3">
        <div class="py-3">
          <router-link to="/rewards" class="text-primary-link">
            {{ $t('message.rewards.title') }}
          </router-link>
          <i class="fal fa-angle-right"></i>
          {{ $t('message.rewards.points_history') }}
        </div>

        <section class="mt-3" v-if="userPoints && userPoints.length > 0">
          <div v-for="(userPoint, index) in userPoints" :key="userPoints">
            <div class="d-flex row align-items-center text-secondary">
              <div class="flex-fill" v-if="userPoint.point_action_type">
                {{ userPoint.point_action_type | multiLangName }}
              </div>
              <div class="text-right flex-fill text-small">
                {{ userPoint.created_at | prettyDate }}
              </div>
            </div>
            <div class="d-flex row">
              <div class="flex-grow-1">
                <div>
                  <label v-if="userPoint.point_type === 'acquired' && userPoint.order">
                    <span
                      v-html="$options.filters.serviceParentName(userPoint.order.service_id, globalState.services)"></span>
                    #{{ userPoint.order.order_code }}
                  </label>
                  <label v-if="userPoint.point_type === 'used' && userPoint.reward">
                    {{ ($i18n.locale === 'th') ? userPoint.reward.title_th : userPoint.reward.title_en }}
                  </label>
                </div>
                <div class="text-small text-secondary">

                </div>
                <div class="text-small text-secondary pt-2" v-if="userPoint.point_type === 'acquired'">
                  <span v-if="userPoint.is_expired && userPoint.is_used == 0">
                    <i class="fas fa-exclamation-triangle -status-pending"></i> {{ $t('message.rewards.points_expired_date') }}
                    {{ userPoint.expire_date | prettyOnlyDate }}
                  </span>
                  <span v-else-if="!userPoint.is_expired">
                    {{ $t('message.rewards.points_will_expire_date') }}
                    {{ userPoint.expire_date | prettyOnlyDate }}
                  </span>
                </div>
              </div>
              <div class="align-self-center">
                <span :class="[(userPoint.is_expired && userPoint.is_used == 0) ? 'text-secondary' : '-status-new']" v-if="userPoint.point_type === 'acquired'">
                  <i class="fal fa-plus"></i>{{ userPoint.points | prettyNumber }}</span>
                <span class="-status-alert" v-else-if="userPoint.point_type === 'used'">
                  <i class="fal fa-minus"></i>{{ userPoint.points | prettyNumber }}
                </span>
                <span class="text-secondary" v-else-if="userPoint.point_type === 'expired'">
                  <i class="fal fa-minus"></i>{{ userPoint.points | prettyNumber }}
                </span>
              </div>
            </div>
            <hr>
          </div>

          <div class="text-center">
            <button class="button -cyan"
                    :disabled="isFetching"
                    @click="fetchMore()"
                    v-if="isMore">
              {{ isFetching ? $t('message.button.loading') :  $t('message.button.load_more') }}
            </button>
          </div>
        </section>

      </div>
    </div>
  </section>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    data () {
      return {
        page: 0
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      }),
      ...mapState('userPoint', ['userPoints', 'isFetching', 'isMore'])
    },
    methods: {
      ...mapActions('userPoint', ['fetchUserPoints']),
      fetchMore () {
        this.page += 1
        const params = {
          user_id: this.user.id,
          page: this.page
        }
        this.fetchUserPoints(params)
      }
    },
    mounted () {
      if (this.user) {
        const params = {
          user_id: this.user.id,
          page: this.page
        }
        this.fetchUserPoints(params)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/reward/UserPoints.vue